module.exports = __webpack_public_path__ + "img/58615d7.jpg";